<div><canvas baseChart
        [type]="'pie'"
        [datasets]="pieChartDatasets"
        [labels]="pieChartLabels"
        [options]="pieChartOptions"
        [plugins]="pieChartPlugins"></canvas></div>
